module.exports = __webpack_public_path__ + "static/media/SEO.2d46687a.svg";